import { PATHS } from '@/constants';

export const ALL_TOPICS_PATH = '/all-topics';
export const ABOUT_PAGE_PATH = '/about-us';
export const CONTACT_PAGE_PATH = '/contact';
export const TODAYS_DAILY_DIGEST_PATH = '/today';
export const CAREERS_PAGE_PATH = '/careers';
export const PRIVACY_POLICY_PATH = '/privacy-policy';
export const TERMS_OF_SERVICE_PATH = '/terms-conditions';
export const COOKIE_POLICY_PATH = '/cookie-policy';
export const PARTNER_WITH_US_PATH = '/partner';
export const PRESS_PATH = '/press';
export const ALLOW_LIST_PATH = '/allowlist';

export function resourcePath(slug?: string) {
  if (!slug) console.warn('"slug" missing from resourcePath()');

  return `/${PATHS.resources}/${slug}`;
}

export function topicPath(slug?: string) {
  if (!slug) console.warn('"slug" missing from topicPath()');

  return `/${PATHS.topics}/${slug}`;
}

export function categoryPath(slug?: string) {
  if (!slug) console.warn('"slug" missing from categoryPath()');

  // TODO update to category path when SEO work is done
  return `/${PATHS.topics}/${slug}`;
}

export function searchPath(searchQuery?: string) {
  if (!searchQuery) console.warn('"searchQuery" missing from searchPath()');

  return `/search?query=${searchQuery}`;
}

export function articlePath(slug?: string, primaryTopicSlug?: string) {
  if (!slug || !primaryTopicSlug)
    console.warn('"slug" or "primaryTopicSlug" missing from articlePath()');

  return `${topicPath(primaryTopicSlug)}/a/${slug}`;
}

export function newsletterPath(slug?: string) {
  if (!slug) console.warn('"slug" missing from newsletterPath()');

  return `/${PATHS.newsletter}/${slug}`;
}

export const EXTERNAL_LINKS = {
  recaptchaTerms: 'https://policies.google.com/terms',
  recaptchaPrivacy: 'https://policies.google.com/privacy',
};

export const SOCIAL_LINKS = {
  facebook: {
    handle: '@Join1440',
    url: 'https://facebook.com/1440Daily/',
  },
  twitter: {
    handle: '@Join1440',
    url: 'https://x.com/1440_Daily',
  },
  instagram: {
    handle: '@Join1440',
    url: 'https://instagram.com/1440daily',
  },
  youtube: {
    handle: '@Join1440',
    url: 'https://youtube.com/@1440daily',
  },
  tiktok: {
    handle: '@Join1440',
    url: 'https://tiktok.com/@1440daily',
  },
  threads: {
    handle: '@Join1440',
    url: 'https://www.threads.net/@1440daily',
  },
};
